import React, { Component } from 'react';
import ReactTable from 'react-table';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import Geral from '../../Utils/Geral';
import Usuario from '../../Utils/Usuario';
import moment from 'moment';
import update from 'immutability-helper';
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from "reactstrap";
import { Collapse } from 'reactstrap';
import 'react-table/react-table.css';
import 'react-dates/lib/css/_datepicker.css';

import './Order-Details.scss';
import ModalItem from '../../Components/ModalPedido/ModalItem';
import ModalBaixa from '../../Components/ModalBaixa/ModalBaixa';
import { NavLink } from 'react-router-dom';

import SendOrderEmail from '../../Components/Send-Order-Email/Send-Order-Email';
import TableHistory from '../../Components/Table-History/Table-History';

import TableHistoryBilling from '../../Components/Table-History-Billing/Table-History-Billing';
import ModalBeneficiarios from '../../Components/Modal-Beneficiarios/Modal-Beneficiarios';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';

import ModalReenvioImpressos from '../../Components/Modal-Reenvio-Impressos/Modal-Reenvio-Impressos';
import ModalBeneficiariosCile from '../../Components/Modal-Beneficiarios-Cile/Modal-Beneficiarios-Cile';
import ModalCodigoPIX from '../../Components/Modal-Codigo-PIX/Modal-Codigo-PIX';
import ModalGerarBoleto from '../../Components/Modal-Gerar-Boleto/Modal-Gerar-Boleto';
import DivPermission from '../../Components/Div-Permission/Div-Permission';




class OrderDetails extends Component {

    constructor(props) {
        super(props);

        this.getOrderDetails = this.getOrderDetails.bind(this);
        this.handleFocusChange = this.handleFocusChange.bind(this);
        this.handleDatesChange = this.handleDatesChange.bind(this);

        this.handleModalItem = this.handleModalItem.bind(this);
        this.toggleModalItem = this.toggleModalItem.bind(this);
        this.toggleModalBaixa = this.toggleModalBaixa.bind(this);
        this.handleCodMembroChange = this.handleCodMembroChange.bind(this);
        this.toggleStatusCancelarItem = this.toggleStatusCancelarItem.bind(this);

        this.transferirTodosItens = this.transferirTodosItens.bind(this);
        this.cancelaPedido = this.cancelaPedido.bind(this);
        this.confirmaCancelamento = this.confirmaCancelamento.bind(this);
        this.toggleEstorno = this.toggleEstorno.bind(this);
        this.handleMotivoCancelamento = this.handleMotivoCancelamento.bind(this);
        this.handleMotivoBrinde = this.handleMotivoBrinde.bind(this);
        this.toggleCollapseCancelamento = this.toggleCollapseCancelamento.bind(this);
        this.toggleCollapseTransferencia = this.toggleCollapseTransferencia.bind(this);

        this.gerarBoleto = this.gerarBoleto.bind(this);
        this.segundaVia = this.segundaVia.bind(this);

        this.estornarPedido = this.estornarPedido.bind(this);
        this.habilitaEstorno = this.habilitaEstorno.bind(this);
        this.habilitaBaixa = this.habilitaBaixa.bind(this);
        this.habilitaTransferencia = this.habilitaTransferencia.bind(this);
        this.habilitaBoleto = this.habilitaBoleto.bind(this);
        this.clickCancelarItem = this.clickCancelarItem.bind(this);

        this.buscaMembro = this.buscaMembro.bind(this);
        this.transferirTodosItens = this.transferirTodosItens.bind(this);

        this.setTimeZoneDtModificacao = this.setTimeZoneDtModificacao.bind(this);

        this.toggleEmail = this.toggleEmail.bind(this);
        this.converterBrinde = this.converterBrinde.bind(this);
        this.converterBrindeConfirmacao = this.converterBrindeConfirmacao.bind(this);

        this.getDadosEntrega = this.getDadosEntrega.bind(this);
        this.getHistoricoLogistico = this.getHistoricoLogistico.bind(this);

        this.toggleModalBeneficiarios = this.toggleModalBeneficiarios.bind(this);
        this.mostrarBeneficiarios = this.mostrarBeneficiarios.bind(this);
        this.enviarMensagemBeneficiario = this.enviarMensagemBeneficiario.bind(this);
        this.toggleModalSucessoMensagem = this.toggleModalSucessoMensagem.bind(this);
        this.botaoSalvarAlteracoesBeneficiario = this.botaoSalvarAlteracoesBeneficiario.bind(this);
        this.adicionarBeneficiario = this.adicionarBeneficiario.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.toggleModalReenvioImpressos = this.toggleModalReenvioImpressos.bind(this);
        this.handleModalReenvio = this.handleModalReenvio.bind(this);
        this.defineMetodoBeneficiarios = this.defineMetodoBeneficiarios.bind(this);
        this.toggleModalBeneficiariosCile = this.toggleModalBeneficiariosCile.bind(this);
        this.mostrarBeneficiariosCile = this.mostrarBeneficiariosCile.bind(this);
        this.toggleModalGerarPix = this.toggleModalGerarPix.bind(this);
        this.habilitaPIX = this.habilitaPIX.bind(this);
        this.copiarCodigo = this.copiarCodigo.bind(this);
        this.obterCodigoPIX = this.obterCodigoPIX.bind(this);
        this.enviarEmail = this.enviarEmail.bind(this);
        this.toggleBoleto = this.toggleBoleto.bind(this);
        this._outsideRange = this._outsideRange.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.onFocusChange = this.onFocusChange.bind(this);
        this.habilitaGerarBoleto = this.habilitaGerarBoleto.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.enviarBoletoAnexo = this.enviarBoletoAnexo.bind(this);
        this.validacaoEmail = this.validacaoEmail.bind(this);
        this.descancelarPedido = this.descancelarPedido.bind(this);
        this.toggleModalConfirmaDescancelamento = this.toggleModalConfirmaDescancelamento.bind(this);
        this.toggleModalRenovacaoAssinatura = this.toggleModalRenovacaoAssinatura.bind(this);


        this.Configurations = new Configurations();


        this.state = {

            modalItem: false,
            modalCancelamento: false,
            modalEstorno: false,
            modalStatusCancelamento: false,

            alertaMotivoCancelamento: false,
            collapseCancelamento: false,
            collapseTransferencia: false,
            orderDetails: this.pedidoMOCK,

            buscaHabilitada: false,
            codMembroBusca: '',
            buscaRealizada: false,
            isLoadingBuscaMembro: false,

            isLoadingEstorno: false,
            isLoadingCancelamento: false,
            motivoCancelamento: '',
            novoAssinante: "",
            modalEmail: false,
            dadosEntrega: [],
            isLoadingEntrega: false,
            entregaCarregada: false,
            historicoLogistico: [],
            isLoadingHistoricoLogistico: false,

            loading: true,

            modalBeneficiarios: false,
            flagBeneficiarioAceite: false,
            listaBeneficiario: [],
            listaBeneficiariosCile: [],
            isLoadingMensagem: false,
            modalSucessoMensagem: false,
            temAlteracao: false,
            isLoadingAlteracoesBeneficiario: false,
            isLoadingAdicionarBeneficiario: false,
            modalReenvioImpressos: false,
            isLoadingSalvarReenvioPeriodicos: false,
            listaIdEdicoes: [],
            pedidoCILE: this.props.pedidoCILE,
            modalBeneficiariosCile: false,
            infosPedido: {},
            modalGerarPix: false,
            isLoadingPix: false,
            pix: {},
            isLoadingEmail: false,
            modalBoleto: false,
            isLoadingBoleto: false,
            enviarBoleto: false,
            dtVencimentoBoleto: moment().add(5, "days"),
            focused: false,
            boletoSucesso: false,
            isLoadingDescancelamento: false,
            modalConfirmaCancelamento: false,
            modalRenovacaoAssinatura: false,
            isLoadingRenovacaoAssinatura: false
        }

        this._phrases = {
            closeDatePicker: "Fechar",
            clearDates: "Limpar datas",
            calendarLabel: "Calendário"
        }

        this.columns = [
            {
                Header: 'Assinante',
                accessor: 'membro',
                className: 'pointer nome-assinante',
                width: 210,
            },
            {
                Header: 'Cod. Membro',
                accessor: 'codMembro',
                className: 'pointer text-center',
                width: 110,
                Cell: row => (<span className={row.value ? '' : 'badge badge-secondary'}> {!!row.value ? row.value : 'Não membro'}</span>)
            },
            {
                Header: 'Produto',
                className: 'pointer text-center',
                accessor: 'produto',
                width: 200
            },
            {
                Header: 'Qtd.',
                className: 'pointer text-center',
                accessor: 'qtd',
                width: 50
            },
            {
                Header: 'Período',
                className: 'pointer text-center',
                accessor: 'periodo',
                width: 100
            },
            {
                Header: 'Familiar',
                className: 'pointer text-center',
                accessor: 'familiar',
                width: 100,
                Cell: row => (<span>{row.value ? "Sim" : "Não"}</span>)

            },
            {
                Header: 'Início',
                accessor: 'dtInicio',
                className: 'text-center pointer',
                width: 120,
                Cell: row => (<span>{moment(row.value).format('DD/MM/YYYY')}</span>)
            },
            {
                Header: 'Fim',
                accessor: 'dtFim',
                className: 'text-center pointer',
                width: 120,
                Cell: row => (<span>{moment(row.value).format('DD/MM/YYYY')}</span>)
            },
            {
                Header: 'Ed. Inicial',
                accessor: 'edicaoInicial',
                className: 'text-center pointer',
                width: 80,
            },
            {
                Header: 'Ed. Final',
                accessor: 'edicaoFinal',
                className: 'text-center pointer',
                width: 80,
            },
            {
                Header: 'Valor',
                accessor: 'valorProduto',
                className: 'text-center pointer',
                width: 100,
                Cell: row => (<span>R$ {row.value !== undefined && row.value !== null ? row.value.toFixed(2).toString().replace('.', ',') : "0,00"}</span>)
            },
            {
                Header: 'Beneficiários',
                accessor: 'temBeneficiario',
                className: 'text-center',
                width: 110,
                Cell: row => {
                    return (row.original.temBeneficiario ? (
                        <div className='row no-gutters'>
                            <div className='col-12'>
                                {row.original.loading ? (
                                    <div className="spinner-border spinner-border-sm text-primary" role="status" />
                                ) : (
                                    <button className="btn btn-sm btn-outline-info" onClick={() => this.defineMetodoBeneficiarios(row.original.idItem)}>Beneficiários</button>
                                )}
                            </div>
                        </div>
                    ) : <React.Fragment></React.Fragment>
                    )
                }
            },
            {
                Header: 'Reenvio',
                className: 'text-center',
                accessor: 'tipoConteudo',
                Cell: row => {
                    const apresentarBotao = this.state.orderDetails.temReenvio.filter(item => item.idItem === row.original.idItem)
                    const nomeBotao = apresentarBotao.length > 0 ? "cancelar" : "cadastrar";
                    const corBotao = apresentarBotao.length > 0 ? "danger" : "success";
                    return (
                        (row.value === 'Impresso' && !this.isPedidoCILE() && this.state.permissaoReenvio && row.original.mostrarBtmReenvio) ?
                            (
                                <button className={`btn btn-sm btn-outline-${corBotao}`} onClick={() => this.handleModalReenvio(row.original)}>{nomeBotao}</button>
                            ) : null
                    )
                }
            },
            // {
            //     Header: 'Cancelar Item',
            //     className: 'text-center pointer',
            //     width: 80,
            //     Cell: row => {

            //         return (this._userRoles.indexOf(1) >= 0 || this._userRoles.indexOf(4) >= 0 || this._userRoles.indexOf(16) >= 0) && !this.state.orderDetails.recorrente && this.state.orderDetails && this.state.orderDetails.itens && this.state.orderDetails.itens.length > 1 ? (
            //             <div className="row no-gutters">
            //                 <div className="col-12 icones">
            //                     {row.original.loading ? (
            //                         <div className="spinner-border spinner-border-sm text-primary" role="status" />
            //                     ) : (
            //                         <button onClick={() => this.toggleStatusCancelarItem({ itemId: row.original.idItem })} className="border-0 bg-transparent">
            //                             <i className={`fas fa-unlink`}></i>
            //                         </button>
            //                     )}
            //                 </div>
            //             </div>
            //         ) : null
            //     }
            // }
        ]
    }

    componentWillMount() {
        let _permissoes = [1, 2, 4, 15, 16, 31];
        const roles = Usuario.getLoggedUser.permissoes.map(item => item.numero);
        this._userRoles = roles;
        const found = roles.some(r => _permissoes.indexOf(r) >= 0);
        if (!found) this.props.history.push({ pathname: '/permissao-negada' });
        else this.getOrderDetails();
        this.setState({ permissaoReenvio: roles.some(r => [1, 25].indexOf(r) >= 0) })
    }

    habilitaEstorno() {
        return this.state.orderDetails.idStatusPagto === 2 && this.state.orderDetails.idStatusPedido < 4 //idStatusPedido 1,2,3
    }

    habilitaBaixa() {
        return !this.state.pedidoCancelado && !this.state.pedidoBrinde && this.state.orderDetails.idStatusPagto !== 2 && this.state.orderDetails.idStatusPagto !== 4 && this.state.orderDetails.idStatusPagto !== 6
    }

    habilitaTransferencia() {
        return !this.state.pedidoCancelado && this.state.orderDetails.transferivel && !this.isPedidoCILE()
    }

    habilitaBoleto() {
        return this.state.orderDetails.idStatusPagto === 1 && !this.state.pedidoCancelado && !this.isPedidoCILE()
    }

    habilitaPIX() {
        return this.state.orderDetails.idStatusPagto === 1 && !this.state.pedidoCancelado && !this.isPedidoCILE()
    }

    toggleEmail() { this.setState({ modalEmail: !this.state.modalEmail }) }

    cancelaPedido() {
        this.setState({ isLoadingCancelamento: true })
        axios.post(this.Configurations.apiBasePath + `/pedidos/${this.props.match.params.idPedido}/cancelamento`, { motivo: this.state.motivoCancelamento }).then(response => {
            this.getOrderDetails();
            this.setState({ motivo: this.state.motivoCancelamento })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingCancelamento: false, modalCancelamento: false }));
    }

    confirmaCancelamento() {
        if (this.state.motivoCancelamento === '') this.setState({ alertaMotivoCancelamento: true });
        else this.setState({ modalCancelamento: !this.state.modalCancelamento, alertaMotivoCancelamento: false });
    }

    badgeType(idStatus) {
        switch (idStatus) {
            case 2:
                return "success";
            case 4:
                return "secondary";
            case 5:
                return "danger";
            case 6:
                return "primary";
            default: // case 1, 3
                return "warning";
        }
    }

    productBadgeType(status) {
        switch (status) {
            case "BS":
                return "primary";
            case "TC":
                return "danger";
            case "RD":
                return "warning";
            default:
                return "info";
        }
    }

    getOrderDetails() {
        this.setState({ loading: true });
        const _idPedido = this.props.match.params.idPedido;
        axios.get(this.Configurations.apiBasePath + `/pedidos/${_idPedido}`).then(response => {
            console.log("RESPONSE DATA ", response.data.data)
            this.setState({
                orderDetails: response.data.data,
                loading: false,
                flagMembro: !!response.data.data.codMembroSolicitante,
                pedidoCancelado: response.data.data.idStatusPedido === 6,
                pedidoBrinde: response.data.data.idStatusPedido === 7,
                pedidoBaixaManual: response.data.data.idStatusPagto === 6,
                pedidoCILE: response.data.data.pedidoCILE,
                email: response.data.data.emailSolicitante,
                motivoCancelamento: response.data.data.motivoCancelamento
            }, () => {
                this.setTimeZoneDtModificacao(this.state.orderDetails.dtModificacaoPedido);
                this.habilitaEstorno();
                if (this.isPedidoCILE() && !this.temProdutoDigital()) {
                    this.getHistoricoLogistico();
                }
            });
        }).catch(this.handleError)
        this.setState({ isLoadingHistorico: true });
        axios.get(this.Configurations.apiBasePath + `/pedidos/${_idPedido}/historico`).then(response => {
            this.setState({ historicoPedido: response.data.data })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingHistorico: false }));
    }

    setTimeZoneDtModificacao(date) {
        const _date = moment(date).add(3, 'hours').format('DD/MM/YY h:mm:ss');
        this.setState({ dtModificacaoPedidoCorrigida: _date });
    }

    handleMotivoCancelamento(e) {
        this.setState({
            motivoCancelamento: e.target.value
        });
    }

    handleMotivoBrinde(e) {
        this.setState({
            motivoBrinde: e.target.value
        });
    }

    handleFocusChange(attr) {
        return function (focusedInput) {
            var dates = this.state.filters[attr];
            dates.focusedInput = focusedInput;
            let newState = {
            };
            newState[attr] = dates;
            this.setState(newState);
        }
    }

    handleDatesChange(attr) {
        return function ({ startDate, endDate }) {
            var dates = this.state.filters[attr];
            dates.startDate = startDate;
            dates.endDate = endDate;
            startDate ? dates.gte = startDate.format('YYYY[-]MM[-]DD') : delete dates.gte;
            endDate ? dates.lte = endDate.format('YYYY[-]MM[-]DD') : delete dates.lte;
            let newState = {
            };
            newState[attr] = dates;
            this.setState(newState);
        }
    }

    handleModalItem(_infosItem) {
        this.setState({ infosModal: _infosItem }, () => this.toggleModalItem())
    }

    handleModalReenvio(item) {
        this.setState({ itemPedido: item }, () => this.toggleModalReenvioImpressos())
    }

    toggleModalItem() { this.setState({ modalItem: !this.state.modalItem }) }

    toggleModalBaixa() { this.setState({ modalBaixa: !this.state.modalBaixa }) }


    toggleCollapseCancelamento() { this.setState({ collapseCancelamento: !this.state.collapseCancelamento }) }
    toggleCollapseTransferencia() { this.setState({ collapseTransferencia: !this.state.collapseTransferencia }) }

    handleCodMembroChange(e) { this.setState({ codMembroBusca: e.target.value.substr(0, 8) }) }

    converterBrindeConfirmacao() {
        this.setState({
            modalBrinde: true
        });
    }

    converterBrinde() {
        if (!this.state.motivoBrinde || this.state.motivoBrinde.trim() === '') {
            this.setState({
                alertaMotivoBrinde: 'O motivo é obrigatório.'
            })
        } else {
            this.setState({ isLoadingBrinde: true });

            axios.post(this.Configurations.apiBasePath + `/pedidos/${this.props.match.params.idPedido}/brinde`, { motivo: this.state.motivoBrinde }).then(response => {
                this.setState({
                    motivoBrinde: undefined,
                    alertaMotivoBrinde: undefined,
                    modalBrinde: false
                }, () => {
                    this.getOrderDetails();
                });
            }).catch(err => {
                this.setState({
                    alertaMotivoBrinde: err.error.message
                })
            }).finally(() => this.setState({ isLoadingBrinde: false }));
        }
    }

    buscaMembro(e) {
        e.preventDefault();
        if (this.state.codMembroBusca === '') {
            this.setState({ alertaBuscaMembro: true });
        }
        else {
            this.setState({ isLoadingBuscaMembro: true })
            axios.get(this.Configurations.apiBasePath + `/membros/${this.state.codMembroBusca}`).then(response => {
                if (response.data.data.message) {
                    this.setState({
                        alertaBuscaMembro: true
                    })
                }
                else {
                    this.setState({
                        buscaRealizada: true,
                        novoAssinante: response.data.data.nome,
                        novoIdUsuario: response.data.data.idUsuario,
                        alertaBuscaMembro: false
                    })
                }
            }).catch(this.handleError).finally(() => this.setState({ isLoadingBuscaMembro: false }));
        }
    }



    transferirTodosItens() {
        this.setState({ isLoadingTransferir: true })
        const _novoIdUsuario = { idUsuario: this.state.novoIdUsuario };
        axios.put(this.Configurations.apiBasePath + `/pedidos/${this.props.match.params.idPedido}`, _novoIdUsuario).then(response => {
            this.setState({
                codMembroBusca: '',
                buscaRealizada: false,
                collapseTransferencia: false
            })
            this.getOrderDetails();
        }).catch(this.handleError).finally(() => this.setState({ isLoadingTransferir: false }));
    }

    gerarBoleto() {
        this.setState({ isLoadingBoleto: true })
        if (moment(this.state.orderDetails.dtVencimentoBoleto).isValid()) {
            this.segundaVia();
        } else this.toggleBoleto();
    }

    segundaVia() {
        axios.get(this.Configurations.apiBasePath + `/pedidos/${this.props.match.params.idPedido}/boleto-2-via`, { idUsuario: this.state.orderDetails.idSolicitante }).then(response => {
            Geral.downloadPDF(response.data.boleto.boleto, `ebs-boleto-${this.props.match.params.idPedido}`)
            this.getOrderDetails();
            this.toggleEmail();
        }).catch(this.handleError).finally(() => this.setState({ isLoadingBoleto: false }));
    }

    estornarPedido() {
        this.setState({ isLoadingEstorno: true })
        axios.post(this.Configurations.apiBasePath + `/pedidos/${this.props.match.params.idPedido}/estorno`).then(response => {
            this.getOrderDetails();
        }).catch(this.handleError).finally(() => this.setState({ isLoadingEstorno: false, modalEstorno: false }));
        this.setState({ isLoadingEstorno: false, modalEstorno: false })
    }

    getDadosEntrega() {
        this.setState({ isLoadingEntrega: true })
        axios.get(this.Configurations.apiBasePath + `/logistica/pedidos/entregas/${this.props.match.params.idPedido}`).then(response => {
            this.setState({
                dadosEntrega: response.data.entregasPedido || [],
                entregaCarregada: true
            })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingEntrega: false }));
    }

    getHistoricoLogistico() {
        this.setState({ isLoadingHistoricoLogistico: true });
        const _idPedido = this.props.match.params.idPedido;
        axios.get(this.Configurations.apiBasePath + `/logistica/pedidos/historico/${_idPedido}`).then(response => {
            this.setState({
                historicoLogistico: response.data.historicoLogistica || []
            });
        }).catch(err => {
            console.error("Erro ao obter histórico logístico:", err);
        }).finally(() => this.setState({ isLoadingHistoricoLogistico: false }));
    }

    isPedidoCILE() {
        const order = this.state.orderDetails;
        if (!order) return false;
        return order.idOrigemRegistro === 6 || order.origemRegistro === 6 || order.origemRegistro === 'Cile' || this.state.pedidoCILE;
    }

    temProdutoDigital() {
        const order = this.state.orderDetails;
        if (!order || !Array.isArray(order.itens)) return false;
        return order.itens.some(item => item.tipoConteudo === 'Digital' || item.idTipoConteudo > 0);
    }

    toggleEstorno() { this.setState({ modalEstorno: !this.state.modalEstorno }) }

    statusColor() {
        let _color = 'primary';
        switch (this.state.orderDetails.idStatusPedido) {
            case 6:
                _color = 'danger';
                break;
            case 7:
                _color = 'info';
                break;
            default:
                _color = 'primary';
                break;
        }

        return _color;
    }

    toggleStatusCancelarItem(o) {
        this.setState({ modalStatusCancelamento: !this.state.modalStatusCancelamento, cancelamentoItemId: o ? o.itemId : undefined });
    }

    clickCancelarItem(o) {
        this.setState({ isLoadingStatusCancelamento: true });

        axios.delete(this.Configurations.apiBasePath + `/pedidos/${this.props.match.params.idPedido}/item/${this.state.cancelamentoItemId}/cancelar-item`).then(response => {
            this.getOrderDetails();
        }).catch(this.handleError).finally(() => this.setState({ isLoadingStatusCancelamento: false, modalStatusCancelamento: false }));
    }

    toggleModalBeneficiarios(index) {
        this.setState({
            indexBeneficiario: index
        }, () => this.setState({
            modalBeneficiarios: !this.state.modalBeneficiarios,
            indexEdicao: undefined
        }))
    }

    mostrarBeneficiarios(idItem, manterModal) {
        const index = this.state.orderDetails.itens.findIndex(item => item.idItem === idItem)
        this.setState({ orderDetails: update(this.state.orderDetails, { itens: { [index]: { loading: { $set: true } } } }) })
        axios.get(this.Configurations.apiBasePath + `/pedidos/${idItem}/beneficiarios`).then(response => {
            this.setState({
                listaBeneficiario: response.data.beneficiario,
                qtdBeneficiarios: response.data.qtdeBeneficiariosDisponivel,
                idItemSelecionado: idItem
            }, () => {
                if (!manterModal) {
                    this.toggleModalBeneficiarios();
                }
            })
        }).catch(this.handleError).finally(() => this.setState({ orderDetails: update(this.state.orderDetails, { itens: { [index]: { loading: { $set: false } } } }) }))
    }

    mostrarBeneficiariosCile(idItem) {
        const index = this.state.orderDetails.itens.findIndex(item => item.idItem === idItem)
        this.setState({ orderDetails: update(this.state.orderDetails, { itens: { [index]: { loading: { $set: true } } } }) })
        axios.get(this.Configurations.apiBasePath + `/pedidos/${idItem}/cile/beneficiarios`).then(response => {
            this.setState({
                listaBeneficiariosCile: response.data.listaBeneficiarios,
                infosPedido: response.data.infosPedido,
                idItemPedido: idItem
            })
            this.toggleModalBeneficiariosCile();
        }).catch(this.handleError).finally(() => this.setState({ orderDetails: update(this.state.orderDetails, { itens: { [index]: { loading: { $set: false } } } }) }))
    }

    enviarMensagemBeneficiario(idItemBeneficiario) {
        this.setState({ isLoadingMensagem: idItemBeneficiario })
        axios.post(this.Configurations.apiBasePath + `/pedidos/${idItemBeneficiario}/mensagem`).then(response => {
            this.toggleModalSucessoMensagem();
        }).catch(this.handleError).finally(() => this.setState({ isLoadingMensagem: false }))
    }

    toggleModalSucessoMensagem() {
        this.setState({ modalSucessoMensagem: !this.state.modalSucessoMensagem })
    }

    botaoSalvarAlteracoesBeneficiario(idItemBeneficiario, alteracoesBeneficiario) {
        this.setState({ isLoadingAlteracoesBeneficiario: true })
        axios.put(this.Configurations.apiBasePath + `/pedidos/${idItemBeneficiario}/beneficiarios`, alteracoesBeneficiario).then(response => {
            this.mostrarBeneficiarios(this.state.idItemSelecionado, true)
        }).catch(this.handleError)
            .finally(() => this.setState({
                isLoadingAlteracoesBeneficiario: false,
                indexEdicao: undefined
            }))
    }

    adicionarBeneficiario(beneficiarioAdicionado) {
        const _body = {
            ...beneficiarioAdicionado, idItemPedido: this.state.idItemSelecionado
        }
        this.setState({ isLoadingAdicionarBeneficiario: true })
        axios.post(this.Configurations.apiBasePath + `/pedidos/beneficiarios`, _body).then(response => {
            this.mostrarBeneficiarios(this.state.idItemSelecionado, true);
        }).catch(this.handleError)
            .finally(() => this.setState({
                isLoadingAdicionarBeneficiario: false,
            }))
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response ? err.response.data.message : "Erro inesperado." })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }


    handleSelectChange(e, o) {
        let _list = this.state.listaIdEdicoes;

        switch (o.action) {
            case "remove-value":
                const _index = _list.findIndex(item => item === o.removedValue);
                _list.splice(_index, 1);
                break;
            case "clear":
                _list = [];
                break;
            default:
                _list.push(o.option);
                break;
        }
        this.setState({
            listaIdEdicoes: _list,
        })
        return o;
    }

    toggleModalReenvioImpressos() {
        this.setState({
            modalReenvioImpressos: !this.state.modalReenvioImpressos
        }, () => {
            if (!this.state.modalReenvioImpressos) {
                this.setState({
                    itemPedido: undefined,
                    listaIdEdicoes: []
                })
            }
        })
    }

    defineMetodoBeneficiarios(idItem) {
        if (this.state.orderDetails.pedidoCILE) {
            this.mostrarBeneficiariosCile(idItem);
        } else this.mostrarBeneficiarios(idItem);
    }

    toggleModalBeneficiariosCile() {
        this.setState({
            modalBeneficiariosCile: !this.state.modalBeneficiariosCile
        })
    }

    toggleModalGerarPix() {
        this.setState({
            modalGerarPix: !this.state.modalGerarPix,
        })
    }

    copiarCodigo(str) {
        const el = document.createElement('textarea');
        el.value = str;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        const selected =
            document.getSelection().rangeCount > 0
                ? document.getSelection().getRangeAt(0)
                : false;
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        if (selected) {
            document.getSelection().removeAllRanges();
            document.getSelection().addRange(selected);
        }
        this.setState({ mensagem: "Código copiado com sucesso!" })
    }

    obterCodigoPIX() {
        this.setState({ isLoadingPix: true })
        axios.post(this.Configurations.apiBasePath + `/pedidos/${this.props.match.params.idPedido}/pagamento/pix`).then(response => {
            this.setState({
                pix: response.data.pix,
            })
            this.toggleModalGerarPix();
            this.getOrderDetails();
        }).catch(this.handleError).finally(() => this.setState({ isLoadingPix: false }))
    }

    enviarEmail() {
        this.setState({ isLoadingEmail: true }, () => {

            const body = { email: this.state.email, idUsuario: this.props.idSolicitante, enviarEmail: this.state.enviarAnexo };

            axios.post(`${this.Configurations.apiBasePath}/pedidos/${this.props.idPedido}/email`, body)
                .then(response => {
                    this.setState({
                        isLoadingEmail: false,
                        erroEmail: false,
                        emailEnviado: true
                    });
                })
                .catch(err => {
                    console.log(err);
                    this.setState({
                        isLoadingEmail: false,
                        erroEmail: true,
                        // email: '',
                        // enviarBoleto: false,
                        // emailEnviado: false,
                    });
                });
        })
    }
    toggleBoleto() {
        this.setState({
            modalBoleto: !this.state.modalBoleto,
            isLoadingBoleto: false,
            enviarBoleto: false,
            dtVencimentoBoleto: moment().add(5, "days"),
            focused: false,
        })
    }
    _outsideRange(day) {
        return day.format() < moment().format();
    }

    onDateChange(date) {
        this.setState({ dtVencimentoBoleto: date })
    }
    onFocusChange(objFocused) {
        this.setState(objFocused);
    }

    habilitaGerarBoleto() {
        let desabilita;
        const _checkbox = this.state.enviarBoleto,
            _emailNulo = !this.validacaoEmail(this.state.email),
            _dtNula = this.state.dtVencimentoBoleto === null;

        if (_checkbox) {
            desabilita = _emailNulo || _dtNula;
        } else {
            desabilita = _dtNula;
        }
        return desabilita
    }

    handleInputChange(e) {
        this.setState({ [e.target.name]: e.target.value })
    }

    enviarBoletoAnexo() {
        this.setState({ enviarBoleto: !this.state.enviarBoleto });
    }

    validacaoEmail(inputEmail) {
        const _usuario = inputEmail.substring(0, inputEmail.indexOf("@"));
        const _dominio = inputEmail.substring(inputEmail.indexOf("@") + 1, inputEmail.length);

        if ((_usuario.length >= 1) &&
            (_dominio.length >= 3) &&
            (_usuario.search("@") === -1) &&
            (_dominio.search("@") === -1) &&
            (_usuario.search(" ") === -1) &&
            (_dominio.search(" ") === -1) &&
            (_dominio.search(".") !== -1) &&
            (_dominio.indexOf(".") >= 1) &&
            (_dominio.lastIndexOf(".") < _dominio.length - 1)) {
            return true;
        }
        else return false;
    }

    descancelarPedido() {
        this.setState({ isLoadingDescancelamento: true })
        axios.post(this.Configurations.apiBasePath + `/pedidos/${this.props.match.params.idPedido}/descancelar`).then(response => {
            this.getOrderDetails();
            // this.toggleCollapseCancelamento();
            this.setState({
                motivoCancelamento: '',
                collapseCancelamento: false
            })
            this.toggleModalConfirmaDescancelamento();
        }).catch(this.handleError).finally(() => this.setState({ isLoadingDescancelamento: false }))
    }

    toggleModalConfirmaDescancelamento() {
        this.setState({ modalConfirmaCancelamento: !this.state.modalConfirmaCancelamento })
    }

    toggleModalRenovacaoAssinatura() {
        this.setState({ modalRenovacaoAssinatura: !this.state.modalRenovacaoAssinatura })
    }

    render() {
        return (
            <div className="row order-details">
                <div className="col-12">
                    <div className="row no-gutters">
                        <div className="col-10">
                            <h2 className="title-1 m-0">Detalhes do pedido</h2>
                        </div>
                        <div className="col-2 text-right">
                            <button onClick={() => window.history.go(-1)} className="btn btn-outline-secondary">voltar</button>
                        </div>
                    </div>
                </div>
                <div className="col-12 py-2">
                    {this.state.loading ? (
                        <div className="row no-gutters">
                            <div className="col-12 py-5 text-center">
                                <div className="spinner-border text-primary" role="status" />
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-6 text-left">
                                            Dados do Pedido ({this.state.orderDetails.idPedido})
                                        </div>
                                        {this.state.orderDetails.dtModificacaoPedido !== null && (
                                            <div className="col-6 text-right">
                                                última alteração: {this.state.dtModificacaoPedidoCorrigida}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="card-body dados-pedido">
                                    <div className={`row py-2 bg-${this.statusColor()} text-white`}>
                                        <div className="col-3 text-left">
                                            <NavLink className="cursor-pointer text-white" to={`/assinante/${this.state.orderDetails.idSolicitante}`} >
                                                <strong>Solicitante:</strong> {this.state.orderDetails.solicitante} ({this.state.flagMembro ? this.state.orderDetails.codMembroSolicitante : 'Não membro'})
                                            </NavLink>
                                        </div>
                                        <div className="col-3 text-center">
                                            <strong>Status: </strong>{this.state.orderDetails.statusPedido}
                                        </div>
                                        <div className="col-3">
                                            <strong>Status pagamento:</strong> <span className={`badge badge-${this.badgeType(this.state.orderDetails.idStatusPagto)}`}>{this.state.orderDetails.statusPagto}</span>
                                        </div>
                                        <div className="col-3 text-right">
                                            <strong>Data de solicitação: </strong>{moment(this.state.orderDetails.dtPedido).format('DD/MM/YY k:mm')}
                                        </div>
                                        <div className='col-12 py-2'>
                                            <strong>Origem do pedido: </strong>{this.state.orderDetails.origemRegistro}
                                        </div>
                                    </div>

                                    <div className="row py-2 align-items-center">
                                        <div className="col-4">
                                            <strong>Tipo de pedido:</strong> {this.state.orderDetails.tipoPedido}
                                        </div>
                                        <div className="col-4">
                                            <strong>Tipo de pagamento:</strong> {this.state.orderDetails.tipoPagto}
                                        </div>
                                        <div className="col-4">
                                            <strong>Tipo de entrega:</strong> {this.state.orderDetails.tipoEntrega}
                                        </div>
                                    </div>
                                    <div className="row py-2 align-items-center">
                                        <div className="col-4">
                                            <strong>Subtotal:</strong> R$ {this.state.orderDetails.valorPedido.toFixed(2).replace('.', ',')}
                                        </div>

                                        <div className="col-4">
                                            <strong>Valor do frete:</strong> R$ {this.state.orderDetails.valorFrete.toFixed(2).replace('.', ',')}
                                        </div>
                                        <div className="col-4">
                                            <strong>Valor de desconto:</strong> R$ {this.state.orderDetails.desconto.toFixed(2).replace('.', ',')}
                                        </div>
                                    </div>
                                    <div className="row py-2 align-items-center">
                                        <div className="col-4">
                                            <strong>Valor total do pedido:</strong> R$ {this.state.orderDetails.valorPedidoFrete.toFixed(2).replace('.', ',')}
                                        </div>

                                        <div className="col-4">
                                            {this.state.orderDetails && this.state.orderDetails.valorPago !== null && (<p className="m-0"><strong>Valor pago:</strong> R$ {this.state.orderDetails.valorPago.toFixed(2).replace('.', ',')}</p>)}
                                        </div>
                                        <div className="col-4">
                                            {this.state.orderDetails.idStatusPagto === 2 && (<p className="m-0"><strong>Data do pagamento:</strong> {moment(this.state.orderDetails.dtPagto).format('DD/MM/YY')}</p>)}
                                        </div>
                                    </div>
                                    {this.state.orderDetails.idOrigemRegistro === 6 && this.state.orderDetails.endereco && (
                                        <div className="row py-2 align-items-center">
                                            <div className="col-8">
                                                <strong>Endereço de entrega:</strong> {this.state.orderDetails.endereco.logradouro}, {this.state.orderDetails.endereco.numero} - {this.state.orderDetails.endereco.complemento} | {this.state.orderDetails.endereco.bairro} - {this.state.orderDetails.endereco.cidade}/{this.state.orderDetails.endereco.uf} - {this.state.orderDetails.endereco.cep}
                                            </div>
                                            {this.isPedidoCILE() && !this.temProdutoDigital() && (
                                                <div className="col-4">
                                                    <strong>Transportadora:</strong> {this.state.orderDetails.transportadora}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    {this.state.pedidoCancelado && (
                                        <div className="row py-2 align-items-center">
                                            <div className="col-12">
                                                <strong>Motivo do cancelamento: </strong>
                                                {this.state.orderDetails.motivoCancelamento}
                                            </div>
                                        </div>
                                    )}
                                    {this.state.pedidoBaixaManual && (
                                        <div className="row py-2 align-items-center">
                                            <div className="col-12">
                                                <strong>Motivo da baixa manual: </strong>
                                                {this.state.orderDetails.motivoBaixaManual}
                                            </div>
                                        </div>
                                    )}
                                    {this.state.pedidoBrinde && (
                                        <div className="row py-2 align-items-center">
                                            <div className="col-12">
                                                <strong>Motivo da conversão para brinde: </strong>
                                                {this.state.orderDetails.motivoBrinde}
                                            </div>
                                        </div>
                                    )}

                                    <div className="row align-items-center pt-2 pb-3 borda-separacao">
                                        <div className="col-4">
                                            {(this.state.orderDetails.idStatusPagto === 1 && this.state.orderDetails.idTipoPagto === 2 && this.state.orderDetails.temBoleto) && (<p className="m-0"><strong>Vencimento boleto:</strong> {moment(this.state.orderDetails.dtVencimentoBoleto).format('DD/MM/YYYY')}</p>)}
                                            {this.state.orderDetails.recorrente && (<span className={`badge badge-success`}>renovação automática</span>)}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="row">
                                                {(this.habilitaPIX()) && (
                                                    <div className="col-3 py-3 text-center">
                                                        {this.state.isLoadingPix ? (
                                                            <div className="spinner-border text-primary" role="status" />
                                                        ) : (
                                                            <button onClick={this.obterCodigoPIX} className={`btn btn-outline-purple`}>Código PIX</button>
                                                        )}
                                                    </div>
                                                )}
                                                {(this.habilitaBoleto()) && (
                                                    <React.Fragment>
                                                        <div className="col-3 py-3 text-center">
                                                            {this.state.isLoadingBoleto ? (
                                                                <div className="spinner-border text-primary" role="status">
                                                                    <span className="sr-only"></span>
                                                                </div>
                                                            ) : (
                                                                <button onClick={this.gerarBoleto} className={`btn btn-outline-success`}>boleto</button>
                                                            )}
                                                        </div>

                                                    </React.Fragment>
                                                )}

                                                {this.habilitaEstorno() && (
                                                    <div className="col-3 py-3 text-center">
                                                        <button disabled={this.state.isLoadingEstorno} onClick={this.toggleEstorno} className="btn btn-outline-info">estornar pedido</button>
                                                    </div>
                                                )}
                                                {(this.habilitaBaixa()) && (
                                                    <div className="col-3 py-3 text-center">
                                                        <button onClick={this.toggleModalBaixa} className="btn btn-outline-primary">baixa de pagamento</button>
                                                    </div>
                                                )}
                                                {(this.habilitaTransferencia()) && (
                                                    <div className="col-3 py-3 text-center">
                                                        <React.Fragment>
                                                            {this.state.flagMembro && (
                                                                <button onClick={this.toggleCollapseTransferencia} className="btn btn-outline-secondary">transferência de pedido</button>
                                                            )}
                                                        </React.Fragment>
                                                    </div>
                                                )}

                                                <div className="col-3 py-3 text-center">
                                                    {(this.state.orderDetails.idStatusPagto === 2 || this.state.orderDetails.idStatusPagto === 3 || this.state.orderDetails.idStatusPagto === 6 || this.state.orderDetails.idStatusPagto === 8) && (!this.state.orderDetails.recorrente) && (!this.state.pedidoCancelado) && (!this.state.pedidoCILE) && !this.isPedidoCILE() && (
                                                        <button className="btn btn-outline-success" onClick={() => this.props.history.push(`/pedidos/individual?idPedido=${this.props.match.params.idPedido}`)}>renovação de assinatura</button>
                                                    )}
                                                </div>

                                                <div className="col-12">
                                                    <Collapse isOpen={this.state.collapseTransferencia}>
                                                        <div className="row align-items-center pb-3 px-3">
                                                            <div className="col-12 border rounded py-3">
                                                                <form className="form-inline">
                                                                    <div className="form-group">
                                                                        <label className="mr-3" htmlFor="codMembro">Transferência de pedido:</label>
                                                                        <input id="codMembro" name="codMembroBusca" className="mr-3 form-control text-center" type="number" value={this.state.codMembroBusca.toString().substr(0, 8)} onChange={this.handleCodMembroChange} placeholder="cód. de membro" />
                                                                    </div>
                                                                    {this.state.isLoadingBuscaMembro ? (
                                                                        <div className="spinner-border text-primary" role="status" />
                                                                    ) : (
                                                                        <button disable={this.state.isLoadingBuscaMembro.toString()} onClick={this.buscaMembro} className="btn btn-outline-secondary">buscar</button>
                                                                    )}
                                                                    {(this.state.buscaRealizada) && (
                                                                        <strong className="m-0 p-0 mx-4">{this.state.novoAssinante}</strong>
                                                                    )}
                                                                    {this.state.buscaRealizada && (
                                                                        <div className="col-12 pt-4 text-center">
                                                                            {this.state.isLoadingTransferir ? (
                                                                                <div className="spinner-border text-primary" role="status" />
                                                                            ) : (
                                                                                <button onClick={this.transferirTodosItens} className="btn btn-outline-secondary">transferir todos os itens do pedido</button>
                                                                            )}
                                                                        </div>
                                                                    )}

                                                                    {this.state.alertaBuscaMembro && (
                                                                        <div className="col-12 text-left">
                                                                            <small className="text-danger">Para prosseguir, por favor insira um cód. de membro válido.</small>
                                                                        </div>
                                                                    )}
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </Collapse>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row py-2">
                                        <div className="col-12">
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="card">
                                                        <div className="card-body p-0">
                                                            <ReactTable
                                                                data={this.state.orderDetails.itens}
                                                                columns={this.columns}
                                                                defaultPageSize={5}
                                                                pages={this.state.pages}
                                                                manual
                                                                loading={this.state.loading}
                                                                className="-striped -highlight"
                                                                headerClassName="ebs-table-header"
                                                                previousText='Anterior'
                                                                nextText='Próximo'
                                                                loadingText='Carregando...'
                                                                noDataText='Nenhum item encontrado.'
                                                                pageText='Página'
                                                                ofText='de'
                                                                rowsText='linhas'
                                                                getTdProps={(state, rowInfo, column, instance) => {
                                                                    return {
                                                                        onClick: (e, handleOriginal) => {
                                                                            if (rowInfo) {
                                                                                if (column.Header === "Cancelar Item") return handleOriginal();
                                                                                else if (column.Header === "Beneficiários") return handleOriginal();
                                                                                else if (column.Header === "Reenvio") return handleOriginal();
                                                                                else !this.state.pedidoCancelado && (this.handleModalItem(rowInfo.original))
                                                                            }
                                                                        }
                                                                    }
                                                                }}

                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-12 pt-4 text-center'>
                                                    {this.state.pedidoCancelado ? (
                                                        <React.Fragment>
                                                            <DivPermission
                                                                arrayPerm={[1, 31]}
                                                                permUser={Usuario.getLoggedUser.permissoes.map(item => item.numero)}
                                                            >
                                                                {this.state.isLoadingDescancelamento ? (
                                                                    <div className="spinner-border text-primary" role="status" />
                                                                ) : (
                                                                    <button className='btn btn-outline-success' onClick={this.toggleModalConfirmaDescancelamento}>Descancelamento de pedido</button>
                                                                )}
                                                            </DivPermission>

                                                        </React.Fragment>
                                                    ) : (
                                                        <React.Fragment>
                                                            <button onClick={this.toggleCollapseCancelamento} className="btn btn-outline-danger mx-2">cancelamento de pedido</button>
                                                            {!this.state.pedidoBrinde && (
                                                                <button onClick={this.converterBrindeConfirmacao} className="btn btn-info mx-2">converter em brinde</button>
                                                            )}
                                                        </React.Fragment>
                                                    )}
                                                </div>


                                                {!this.state.pedidoCancelado && (
                                                    <div className="col-12">
                                                        <Collapse isOpen={this.state.collapseCancelamento}>
                                                            <div className="row pt-3">
                                                                <div className="offset-3 col-6">
                                                                    <div className="form-group m-0">
                                                                        <label htmlFor="motivo">Insira o motivo de cancelamento:</label>
                                                                        <textarea id="motivo" type="text" className="form-control" name="motivo" value={this.state.motivoCancelamento} onChange={this.handleMotivoCancelamento} />
                                                                    </div>
                                                                </div>
                                                                {this.state.alertaMotivoCancelamento && (
                                                                    <div className="col-12 text-center">
                                                                        <small className="text-danger">Para prosseguir, por favor insira o motivo do cancelamento.</small>
                                                                    </div>
                                                                )}
                                                                <div className="col-12 pt-4 text-center">
                                                                    <button onClick={this.confirmaCancelamento} className="btn btn-danger">cancelar pedido</button>
                                                                </div>
                                                            </div>
                                                        </Collapse>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    {!this.isPedidoCILE() && (
                                        <div className="row py-2">
                                            <div className="col-12">
                                                <h4>Histórico de entregas</h4>
                                                <hr />
                                                <button className="btn btn-primary" onClick={this.getDadosEntrega} disabled={this.state.isLoadingEntrega}>
                                                    {this.state.isLoadingEntrega && (<i className="fas fa-spinner fa-spin mr-2"></i>)}
                                                    {this.state.dadosEntrega.length === 0 ? "Carregar histórico de entregas" : "Atualizar histórico de entregas"}
                                                </button>
                                            </div>
                                            {this.state.dadosEntrega.length > 0 && (
                                                <div className="col-12">
                                                    <div className="delivery-table mt-3">
                                                        <table className="table table-striped table-hover">
                                                            <thead className="thead-dark">
                                                                <tr>
                                                                    <th scope="col">Pessoa</th>
                                                                    <th scope="col">Edição</th>
                                                                    <th scope="col">Produto</th>
                                                                    <th scope="col">Número da Remessa</th>
                                                                    <th scope="col">Nome local de entrega</th>
                                                                    <th scope="col">Transportadora</th>
                                                                    <th scope="col">Data da remessa</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {this.state.dadosEntrega.map((row, index) => {
                                                                    return (<tr key={index}>
                                                                        <td>{row.nome}</td>
                                                                        <th scope="row">{row.edicao}</th>
                                                                        <td>{row.sigla}</td>
                                                                        <td>{row.idRemessa}</td>
                                                                        <td>{row.nomeLocalEntrega}</td>
                                                                        <td>{row.transportadora}</td>
                                                                        <td>{row.dtCriacao && moment(row.dtCriacao).format('DD/MM/YYYY')}</td>
                                                                    </tr>)
                                                                })}

                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            )}
                                            {this.state.entregaCarregada && this.state.dadosEntrega.length === 0 && (
                                                <div className="col-12">
                                                    <div className="alert alert-info mt-3 mb-0">
                                                        Ainda não há registro de histórico de entrega.
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </>
                    )}

                </div>
                {(this.isPedidoCILE() && !this.temProdutoDigital()) && (
                    <div className="col-12 py-2">
                        <div className="card">
                            <div className="card-header">
                                <div className="row align-items-center">
                                    <div className="col-8">
                                        Histórico de Atualizações Logísticas
                                    </div>
                                    <div className="col-4 text-right">
                                        <button
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={this.getHistoricoLogistico}
                                            disabled={this.state.isLoadingHistoricoLogistico}
                                        >
                                            {this.state.isLoadingHistoricoLogistico && (<i className="fas fa-spinner fa-spin mr-1"></i>)}
                                            Atualizar
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-0">
                                {this.state.isLoadingHistoricoLogistico ? (
                                    <div className="row no-gutters">
                                        <div className="col-12 py-5 text-center">
                                            <div className="spinner-border text-primary" role="status" />
                                        </div>
                                    </div>
                                ) : (
                                    <ReactTable
                                        data={this.state.historicoLogistico}
                                        columns={[
                                            {
                                                Header: 'Data/Hora',
                                                accessor: row => row.dtCriacao || row.dtModificacao || row.data,
                                                id: 'dtCriacao',
                                                className: 'text-center',
                                                width: 180,
                                                Cell: row => row.value ? <span>{moment(row.value).format('DD/MM/YYYY HH:mm')}</span> : <span>-</span>
                                            },
                                            {
                                                Header: 'Status',
                                                accessor: row => row.statusEntrega || row.nome || row.status || row.situacao || '-',
                                                id: 'status',
                                                className: 'text-center',
                                                width: 250
                                            },
                                            {
                                                Header: 'Descrição',
                                                accessor: row => row.descricao || row.mensagem || row.detalhe || row.historico || row.observacao || '-',
                                                id: 'descricao',
                                                className: 'text-left'
                                            }
                                        ]}
                                        defaultPageSize={5}
                                        className="-striped -highlight"
                                        headerClassName="ebs-table-header"
                                        previousText='Anterior'
                                        nextText='Próximo'
                                        loadingText='Carregando...'
                                        noDataText='Nenhum histórico de atualização logística encontrado.'
                                        pageText='Página'
                                        ofText='de'
                                        rowsText='linhas'
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                )}
                <div className="col-12 py-2">
                    {this.state.isLoadingHistorico ? (
                        <div className="row no-gutters">
                            <div className="col-12 py-5 text-center">
                                <div className="spinner-border text-primary" role="status" />
                            </div>
                        </div>
                    ) : (
                        <div className="card">
                            <div className="card-header">
                                Histórico do Pedido
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-12">
                                        <TableHistory
                                            historicoPedido={this.state.historicoPedido}
                                            pages={this.state.pages}
                                            loading={this.state.isLoadingHistorico}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                {!this.state.loading && (
                    <div className="col-12 py-3">
                        <TableHistoryBilling
                            historicoFaturamento={this.state.orderDetails.listaRetornoProcessamento}
                        />
                    </div>
                )}
                <Modal isOpen={this.state.modalStatusCancelamento} toggle={this.toggleStatusCancelarItem}>
                    <ModalHeader toggle={this.toggleStatusCancelarItem}>Confirmar cancelamento de item</ModalHeader>
                    <ModalBody>
                        <p className="m-0">
                            Tem certeza que deseja cancelar esse item do pedido?<br />
                            Essa ação <strong>NÃO</strong> criará um novo pedido com o item selecionado e não poderá ser revertida.
                        </p>
                    </ModalBody>
                    <ModalFooter>
                        {this.state.isLoadingStatusCancelamento ? (
                            <div className="spinner-border text-primary" role="status" />
                        ) : (
                            <div>
                                <Button disabled={this.state.isLoadingStatusCancelamento} color={`success`} onClick={() => this.clickCancelarItem({})}>confirmar</Button>
                                {' '}<Button color="secondary" onClick={this.toggleStatusCancelarItem}>voltar</Button>
                            </div>
                        )}
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.modalItem} toggle={this.toggleModalItem} className="" size="lg">
                    <ModalBody>
                        <ModalItem
                            infosModal={this.state.infosModal}
                            toggle={this.toggleModalItem}
                            idPedido={this.props.match.params.idPedido}
                            codMembroSolicitante={this.state.orderDetails && this.state.orderDetails.codMembroSolicitante}
                            atualizaPedido={this.getOrderDetails}
                            history={this.props.history}
                            flagMembro={this.state.flagMembro}
                            pedidoCILE={this.state.pedidoCILE}
                        />
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.modalBaixa} toggle={this.toggleModalBaixa} className="" size="lg">
                    <ModalBody>
                        <ModalBaixa
                            toggle={this.toggleModalBaixa}
                            atualizaPedido={this.getOrderDetails}
                            idSolicitante={this.state.orderDetails ? this.state.orderDetails.idSolicitante : null}
                            idPedido={this.props.match.params.idPedido}
                        />
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.modalCancelamento} toggle={this.confirmaCancelamento}>
                    <ModalHeader toggle={() => this.setState({ modalCancelamento: !this.state.modalCancelamento })}>Cancelamento de pedido</ModalHeader>
                    <ModalBody>
                        Deseja confirmar o cancelamento do pedido? Essa ação não poderá ser revertida.
                    </ModalBody>
                    <ModalFooter>
                        {this.state.isLoadingCancelamento ? (
                            <div className="spinner-border text-primary" role="status" />
                        ) : (
                            <Button disabled={this.state.isLoadingCancelamento} color="danger" onClick={this.cancelaPedido}>confirmar</Button>
                        )}
                        {' '}<Button color="secondary" onClick={() => this.setState({ modalCancelamento: !this.state.modalCancelamento })}>voltar</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.modalBrinde} toggle={this.confirmaBrinde}>
                    <ModalHeader toggle={() => this.setState({ modalBrinde: !this.state.modalBrinde, motivoBrinde: undefined })}>Conversão de pedido para brinde</ModalHeader>
                    <ModalBody>
                        Tem certeza de que deseja converter esse pedido em brinde? Essa ação não poderá ser revertida. <br />

                        <div className="form-group mt-4">
                            <label htmlFor="txtMotivoBrinde">Descreva o motivo do brinde:</label>
                            <textarea id="motivoBrinde" type="text" className="form-control" name="motivoBrinde" value={this.state.motivoBrinde} onChange={this.handleMotivoBrinde} />
                            {this.state.alertaMotivoBrinde && (<small className="text-danger">{this.state.alertaMotivoBrinde}</small>)}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        {this.state.isLoadingBrinde ? (
                            <div className="spinner-border text-primary" role="status" />
                        ) : (
                            <Button disabled={this.state.isLoadingCancelamento} color="danger" onClick={this.converterBrinde}>confirmar</Button>
                        )}
                        {' '}<Button color="secondary" onClick={() => this.setState({ modalBrinde: !this.state.modalBrinde, motivoBrinde: undefined })}>voltar</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.modalEstorno} toggle={this.toggleEstorno}>
                    <ModalHeader toggle={this.toggleEstorno}>Estorno de pedido</ModalHeader>
                    <ModalBody>
                        Deseja confirmar o estorno? Essa ação não poderá ser revertida.
                    </ModalBody>
                    <ModalFooter>
                        {this.state.isLoadingEstorno ? (
                            <div className="spinner-border text-primary" role="status" />
                        ) : (
                            <Button disabled={this.state.isLoadingEstorno} color="danger" onClick={this.estornarPedido}>confirmar</Button>
                        )}
                        {' '}<Button color="secondary" onClick={this.toggleEstorno}>voltar</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.modalSucessoMensagem} toggle={this.toggleModalSucessoMensagem}>
                    <ModalHeader toggle={this.toggleModalSucessoMensagem}></ModalHeader>
                    <ModalBody>
                        A mensagem foi enviada ao beneficiário.
                    </ModalBody>
                    <ModalFooter>
                        <Button color="success" onClick={this.toggleModalSucessoMensagem}>ok</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.modalConfirmaCancelamento} toggle={this.toggleModalConfirmaDescancelamento}>
                    <ModalHeader toggle={this.toggleModalConfirmaDescancelamento}>Descancelamento de pedido</ModalHeader>
                    <ModalBody>
                        Deseja confirmar o descancelamento do pedido? Essa ação não poderá ser revertida.
                    </ModalBody>
                    <ModalFooter>
                        {this.state.isLoadingDescancelamento ? (
                            <div className="spinner-border text-primary" role="status" />
                        ) : (
                            <Button disabled={this.state.isLoadingDescancelamento} color="danger" onClick={this.descancelarPedido}>confirmar</Button>
                        )}
                        {' '}<Button color="secondary" onClick={this.toggleModalConfirmaDescancelamento}>voltar</Button>
                    </ModalFooter>
                </Modal>
                {/* <Modal size="lg" className='modal-renovacao' isOpen={this.state.modalRenovacaoAssinatura} toggle={this.toggleModalRenovacaoAssinatura}>
                    <ModalHeader toggle={this.toggleModalRenovacaoAssinatura}>Renovação de assinatura</ModalHeader>
                    <ModalBody>
                        <p className='m-0 pb-3'>Deseja renovar a assinatura abaixo?</p>
                        <table className='tabela-copia-pedido col-12 table w-100 text-center table-bordered'>
                            <thead>
                                <tr>
                                    <th>Assinante</th>
                                    <th>Produto</th>
                                    <th>Qtd</th>
                                    <th>Perído</th>
                                    <th>Familiar</th>
                                    <th>Início</th>
                                    <th>Fim</th>
                                    <th>Ed.inicial</th>
                                    <th>Ed.final</th>
                                    <th>Valor</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Noemia Fukumoto</td>
                                    <td>Brasil Seikyo</td>
                                    <td>1</td>
                                    <td>Mensal</td>
                                    <td>Não</td>
                                    <td>10/08/2024</td>
                                    <td>24/08/2024</td>
                                    <td>2665</td>
                                    <td>2666</td>
                                    <td>R$ 20,00</td>
                                    <td><button className='btn btn-outline-info'>Beneficiários</button></td>
                                </tr>
                            </tbody>
                        </table>
                    </ModalBody>
                    <ModalFooter>
                        {this.state.isLoadingRenovacaoAssinatura ? (
                            <div className="spinner-border text-primary" role="status" />
                        ) : (
                            <Button disabled={this.state.isLoadingRenovacaoAssinatura} color="success" onClick={this.renovarAssinatura}>renovar</Button>
                        )}
                        {' '}<Button color="secondary" onClick={this.toggleModalRenovacaoAssinatura}>voltar</Button>
                    </ModalFooter>
                </Modal> */}

                {!!this.state.orderDetails && (
                    <ModalGerarBoleto
                        isOpen={this.state.modalBoleto}
                        toggleBoleto={this.toggleBoleto}
                        orderDetails={this.state.orderDetails}
                        getOrderDetails={this.getOrderDetails}
                    />
                )}

                <ModalBeneficiarios
                    isOpen={this.state.modalBeneficiarios}
                    toggle={this.toggleModalBeneficiarios}
                    listaBeneficiario={this.state.listaBeneficiario}
                    flagBeneficiarioAceite={true}
                    enviarMensagem={this.enviarMensagemBeneficiario}
                    isLoadingMensagem={this.state.isLoadingMensagem}
                    botaoSalvarAlteracoesBeneficiario={this.botaoSalvarAlteracoesBeneficiario}
                    isLoadingAlteracoesBeneficiario={this.state.isLoadingAlteracoesBeneficiario}
                    setIndexEdicao={(index) => this.setState({ indexEdicao: index })}
                    indexEdicao={this.state.indexEdicao}
                    qtdBeneficiarios={this.state.qtdBeneficiarios}
                    isLoadingAdicionarBeneficiario={this.state.isLoadingAdicionarBeneficiario}
                    adicionarBeneficiario={this.adicionarBeneficiario}
                />

                {this.state.infosPedido && (
                    <ModalBeneficiariosCile
                        isOpen={this.state.modalBeneficiariosCile}
                        toggle={this.toggleModalBeneficiariosCile}
                        listaBeneficiariosCile={this.state.listaBeneficiariosCile}
                        infos={this.state.infosPedido}
                        email={this.state.orderDetails ? this.state.orderDetails.emailSolicitante : ""}
                    />
                )}


                {!!this.state.itemPedido && (
                    <ModalReenvioImpressos
                        isOpen={this.state.modalReenvioImpressos}
                        toggle={this.toggleModalReenvioImpressos}
                        listaIdEdicoes={this.state.listaIdEdicoes}
                        handleSelectChange={this.handleSelectChange}
                        item={this.state.itemPedido}
                        dadosReenvio={(!!this.state.orderDetails.temReenvio && this.state.orderDetails.temReenvio.length > 0) ? this.state.orderDetails.temReenvio.filter(i => i.idItem === this.state.itemPedido.idItem)[0] : undefined}
                        getOrderDetails={this.getOrderDetails}
                    />
                )}

                <SendOrderEmail
                    toggleEmail={this.toggleEmail}
                    idSolicitante={this.state.orderDetails ? this.state.orderDetails.idSolicitante : undefined}
                    email={this.state.orderDetails ? this.state.orderDetails.emailSolicitante : ""}
                    opened={this.state.modalEmail}
                    idPedido={this.props.match.params.idPedido}
                    idPagto={this.state.orderDetails ? this.state.orderDetails.idTipoPagto : undefined}
                    orderDetails={this.state.orderDetails}
                    id={this.props.match.params.idPedido}

                />
                {!!this.state.pix && (
                    <ModalCodigoPIX
                        isOpen={this.state.modalGerarPix}
                        toggle={this.toggleModalGerarPix}
                        apiCodigoPIX={this.obterCodigoPIX}
                        pix={this.state.pix}
                        idPedido={this.props.match.params.idPedido}
                        email={this.state.orderDetails ? this.state.orderDetails.emailSolicitante : ""}
                    />
                )}

                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                />
            </div>
        )
    }
}

export default OrderDetails;